import { render, staticRenderFns } from "./CHANGELOG.md?vue&type=template&id=190a00fe&"
import script from "./CHANGELOG.md?vue&type=script&lang=js&"
export * from "./CHANGELOG.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CHANGELOG.md"
export default component.exports